import React, { useEffect, useState } from "react";
import { Confetti } from "./Confetti/Confetti";

export const Celebration = () => {
  const [isConfetti, setIsConfetti] = useState(false);

  useEffect(() => {
    setIsConfetti(true);
    return () => {
      setIsConfetti(false);
    };
  }, []);

  return (
    <>
      <canvas id="canvas" style={{
        position: "absolute",
        height: "100%" }}>
        {isConfetti && <Confetti />}
      </canvas>
    </>
  );
};
